<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="角色名称" prop="roleName">
				<el-input clearable v-model="editForm.roleName" class="input_200px" size="small" auto-complete="off" placeholder="请输入角色名称"></el-input>
			</el-form-item>
			<el-form-item label="角色描述" prop="desc">
				<el-input v-model="editForm.desc" class="input_200px" type="textarea" auto-complete="off" placeholder="请输入角色描述"></el-input>
			</el-form-item>
			<el-form-item label="首页模板" prop="homePageTemplateKeyId">
				<el-select v-model="editForm.homePageTemplateKeyId" class="input_200px" size="small" filterable clearable placeholder="不选则使用原默认工作台">
					<el-option v-for="item in homePageTemplateList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
				<el-button v-if="canPreview && editForm.homePageTemplateKeyId" type="text" size="small" @click="previewHome">预览</el-button>
				<div class="tips">该角色的账号登录后展示此模板对应的首页；不选则展示原默认工作台。</div>
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
		</div>
		<home-preview ref="homePreview" />
	</el-drawer>
</template>

<script>
import { SaveRoleInfo, GetRoleInfoDetail, GetHomePageTemplateDropList } from "../../../api/userApi.js";
import { homePageRequest } from "@/api/homePageApi";
import HomePreview from "./homePreview.vue";
export default {
	components: { HomePreview },
	props: { canPreview: Boolean },
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			homePageTemplateList: [], //首页模板下拉（角色关联首页模板用）
			editForm: {
				keyId: "",
				roleName: "",
				desc: "",
				homePageTemplateKeyId: ""
			},
			// rules 表单验证
			rules: {
				roleName: [
					{
						required: true,
						message: "请输入角色名称",
						trigger: "blur"
					}
				]
			}
		};
	},
	computed: {},
	watch: {},

	methods: {
		async previewHome() { try { const d=await homePageRequest('Detail',{keyId:this.editForm.homePageTemplateKeyId,action:'published'});this.$refs.homePreview.open(d.template.name,d.items); }catch(e){this.$message.error(e.message);} },
		// 获取首页模板下拉（角色关联首页模板用）
		getHomePageTemplateList() {
			GetHomePageTemplateDropList({}).then((res) => {
				if (res.code == 1) {
					this.homePageTemplateList = res.data || [];
				}
			});
		},
		//显示编辑界面
		editShow(row) {
			this.getHomePageTemplateList();
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetRoleInfoDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm = res.data;
							// 未关联模板时回填空串，避免 el-select 绑定 null
							this.editForm.homePageTemplateKeyId = res.data.homePageTemplateKeyId || "";
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("角色信息获取失败!");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveRoleInfo(this.editForm)
						.then((res) => {
							this.editFormVisible = false;
							this.loading = false;
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "角色保存成功！"
								});
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("角色保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
.tips {
	color: var(--app-text-muted);
	font-size: 12px;
	line-height: 18px;
	margin-top: 4px;
}
</style>
